import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";
import { GemMark } from "./Logo";

const Row = ({ href, icon: Icon, label, value, testid }) => {
  const Tag = href ? "a" : "div";
  return (
    <Tag href={href} data-testid={testid} className="group flex items-center justify-between gap-4 border-b border-white/10 py-7">
      <div className="flex min-w-0 items-center gap-5">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/15 text-amber-300 transition-colors group-hover:bg-amber-400 group-hover:text-[#0B0F17]">
          <Icon className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-slate-400">{label}</p>
          <p className="break-words font-display text-base font-bold text-white min-[420px]:text-xl sm:text-3xl">{value}</p>
        </div>
      </div>
      {href && <ArrowUpRight className="h-6 w-6 shrink-0 text-slate-400 transition-transform duration-300 group-hover:rotate-45 group-hover:text-amber-300" />}
    </Tag>
  );
};

export const Contact = () => (
  <section id="contact" className="border-t border-white/5 bg-[#0d1220]" data-testid="contact-section">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-32">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Talk to us</Eyebrow>
        <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1] tracking-tight text-white sm:text-5xl">Rather just call?</h2>
        <p className="mt-6 max-w-sm text-base text-slate-300">Questions about a service, a special request or a large space — reach us directly.</p>
      </Reveal>
      <Reveal delay={0.1} className="min-w-0 lg:col-span-7">
        <Row href={CONTACT.phoneHref} icon={Phone} label="Call" value={CONTACT.phone} testid="contact-phone-link" />
        <Row href={CONTACT.emailHref} icon={Mail} label="Email" value={CONTACT.email} testid="contact-email-link" />
        <Row icon={MapPin} label="Service area" value={CONTACT.area} testid="contact-area" />
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/5 pt-16" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col justify-between gap-6 px-5 sm:flex-row sm:px-8">
      <p className="text-sm text-slate-400">© {new Date().getFullYear()} Citrine Home Solutions. All rights reserved.</p>
      <a href="/admin" data-testid="footer-admin-link" className="text-sm text-slate-400 hover:text-amber-300">Owner login</a>
    </div>
    <div className="mt-10 flex items-end justify-center gap-4 px-4 pb-4">
      <span className="select-none font-display text-[22vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.06]">CITRINE</span>
      <GemMark className="mb-[3vw] hidden h-[8vw] w-[8vw] sm:block" />
    </div>
  </footer>
);
